import React from 'react';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Redirect, Switch } from 'react-router-dom';
import AshraeGuidanceConnected from './AshraeGuidanceConnected/AshraeGuidanceConnected';
import NwsHeatIndexGuidanceConnected from './NwsHeatIndexGuidance/NwsHeatIndexGuidanceConnected';
import envConfig from '../../../envConfig';
import { sessionHash } from '../../../utility/remoteServiceUtil';
import RaaAuthenticatedRemoteService from '../../../utility/RaaAuthenticatedRemoteService';
import RaaRoute from '../../common/RaaRoute';

class GuidanceConnected extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      latestSamples: {},
    };
  }

  componentDidMount() {
    this.getSampleList();
  }

  getSampleList() {
    return RaaAuthenticatedRemoteService.globalInstance()
      .get(`${envConfig.apiUrl}/api/v1/device-data/latest-samples?auth_token=${sessionHash}`)
      .then((responseData) => {
        const { sampleList } = responseData;
        this.setState({ latestSamples: sampleList });
      })
      .catch(() => {
        this.setState({ latestSamples: {} });
      });
  }

  render() {
    const { latestSamples } = this.state;
    return (
      <div>
        <Nav variant="tabs" className="mb-3">
          <Nav.Item>
            <LinkContainer to="/s/guidance/established/ashrae-data-center">
              <Nav.Link>ASHRAE - Data Center</Nav.Link>
            </LinkContainer>
          </Nav.Item>
          <Nav.Item>
            <LinkContainer to="/s/guidance/established/nws-heat-index">
              <Nav.Link>NWS - Heat Index</Nav.Link>
            </LinkContainer>
          </Nav.Item>
        </Nav>
        <Switch>
          <RaaRoute path="/s/guidance/established" exact>
            <Redirect to="/s/guidance/established/ashrae-data-center" />
          </RaaRoute>
          <RaaRoute path="/s/guidance/established/ashrae-data-center" exact>
            <AshraeGuidanceConnected
              latestSamples={latestSamples}
            />
          </RaaRoute>
          <RaaRoute path="/s/guidance/established/nws-heat-index" exact>
            <NwsHeatIndexGuidanceConnected latestSamples={latestSamples} />
          </RaaRoute>
        </Switch>
      </div>
    );
  }
}

export default GuidanceConnected;
